/**
 * GoNOW API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 2020-12-7
 * Contact: info@zero-spec.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
* The SensorV1RecordMeta model module.
* @module model/SensorV1RecordMeta
* @version 2020-12-7
*/
export default class SensorV1RecordMeta {
    /**
    * Constructs a new <code>SensorV1RecordMeta</code>.
    * @alias module:model/SensorV1RecordMeta
    * @class
    * @param lat {Number} 緯度
    * @param lng {Number} 経度
    * @param voltage {Number} 電圧
    * @param maxTemp {Number} 最高温度
    * @param minTemp {Number} 最低温度
    * @param rssi {Number} RSSI
    * @param span {Number} 受信間隔 (秒)
    */

    constructor(lat, lng, voltage, maxTemp, minTemp, rssi, span) {
        
        
        this['lat'] = lat;
        this['lng'] = lng;
        this['voltage'] = voltage;
        this['maxTemp'] = maxTemp;
        this['minTemp'] = minTemp;
        this['rssi'] = rssi;
        this['span'] = span;
        
    }

    /**
    * Constructs a <code>SensorV1RecordMeta</code> from a plain JavaScript object, optionally creating a new instance.
    * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
    * @param {Object} data The plain JavaScript object bearing properties of interest.
    * @param {module:model/SensorV1RecordMeta} obj Optional instance to populate.
    * @return {module:model/SensorV1RecordMeta} The populated <code>SensorV1RecordMeta</code> instance.
    */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new SensorV1RecordMeta();
                        
            
            if (data.hasOwnProperty('lat')) {
                obj['lat'] = ApiClient.convertToType(data['lat'], 'Number');
            }
            if (data.hasOwnProperty('lng')) {
                obj['lng'] = ApiClient.convertToType(data['lng'], 'Number');
            }
            if (data.hasOwnProperty('voltage')) {
                obj['voltage'] = ApiClient.convertToType(data['voltage'], 'Number');
            }
            if (data.hasOwnProperty('maxTemp')) {
                obj['maxTemp'] = ApiClient.convertToType(data['maxTemp'], 'Number');
            }
            if (data.hasOwnProperty('minTemp')) {
                obj['minTemp'] = ApiClient.convertToType(data['minTemp'], 'Number');
            }
            if (data.hasOwnProperty('rssi')) {
                obj['rssi'] = ApiClient.convertToType(data['rssi'], 'Number');
            }
            if (data.hasOwnProperty('span')) {
                obj['span'] = ApiClient.convertToType(data['span'], 'Number');
            }
        }
        return obj;
    }

    /**
    * 緯度
    * @member {Number} lat
    */
    'lat' = undefined;
    /**
    * 経度
    * @member {Number} lng
    */
    'lng' = undefined;
    /**
    * 電圧
    * @member {Number} voltage
    */
    'voltage' = undefined;
    /**
    * 最高温度
    * @member {Number} maxTemp
    */
    'maxTemp' = undefined;
    /**
    * 最低温度
    * @member {Number} minTemp
    */
    'minTemp' = undefined;
    /**
    * RSSI
    * @member {Number} rssi
    */
    'rssi' = undefined;
    /**
    * 受信間隔 (秒)
    * @member {Number} span
    */
    'span' = undefined;




}
